export default __webpack_public_path__ + "2ca673247598bac2c4081030b7cd3c6a.mp3";